import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Megaphone: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m315 615h-105v-60h30v30h75c8.27 0 15-6.73 15-15v-305h30v305c0 24.81-20.19 45-45 45z' />
    <path d='m240 525v60h-30v-30c0-16.57 13.43-30 30-30z' />
    <path d='m625.1 617.36c-3.36 0-6.75-.49-10.08-1.48l-495.02-147.28v-157.16l494.92-148.9c10.71-3.22 21.99-1.24 30.97 5.43 8.97 6.67 14.12 16.91 14.12 28.09v386.28c0 11.16-5.13 21.38-14.08 28.06-6.16 4.59-13.41 6.97-20.82 6.97zm-475.1-171.14 473.57 140.9c2.09.62 3.66-.22 4.42-.78.75-.56 2.01-1.83 2.01-4.01v-386.27c0-2.19-1.26-3.45-2.02-4.01-.75-.56-2.33-1.41-4.42-.78l-473.56 142.48v112.48z' />
  </IconBase>
));

Megaphone.displayName = 'Megaphone';

export default Megaphone;
